import { render, staticRenderFns } from "./Crisps.vue?vue&type=template&id=9a04c12c&scoped=true"
import script from "./Crisps.vue?vue&type=script&lang=js"
export * from "./Crisps.vue?vue&type=script&lang=js"
import style0 from "./Crisps.vue?vue&type=style&index=0&id=9a04c12c&prod&lang=less&scoped=true"
import style1 from "./Crisps.vue?vue&type=style&index=1&id=9a04c12c&prod&lang=less&scoped=true"
import style2 from "./Crisps.vue?vue&type=style&index=2&id=9a04c12c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a04c12c",
  null
  
)

export default component.exports